import { ReactElement } from 'react';
import { createSavingArray, createProfitArray, interestGraphOptions } from '../utils';
import InterestGraphBase from './InterestGraphBase';

const savingsData = createSavingArray(50, 30, 50, true);
const profitData = createProfitArray(7, 50, 30, 50, true);
const textPath = {
  title: 'course2.part3.interest_example_graph_1.title',
  subtitle: 'course2.part3.interest_example_graph_1.subtitle',
  altText: 'course2.part3.interest_example_graph_1.alt_text',
  estimatedSave: 'course2.part3.interest_example_graph_1.estimated_save',
  acccountSaving: 'course2.part3.interest_example_graph_1.acccount_saving',
};
const specs = {
  investmentAmount: 50,
  accountSavings: 50,
  profitExpected: 7,
  investmentTime: 30,
};

const InterestGraph1 = (): ReactElement => {
  const options = interestGraphOptions(profitData, savingsData);
  return <InterestGraphBase options={options} text={textPath} specs={specs} />;
};

export default InterestGraph1;
